/**
 * Check if a string contains a substring.
 * @param subject   The string to check.
 * @param substring The substring to check for.
 * @returns         'false' if 'subject' does not contain 'substring', 'true' otherwise.
 */
export function containsSubstring(subject: string, substring: string): boolean {
    return subject.toLowerCase().indexOf(substring.toLowerCase()) !== -1;
}
